// extracted by mini-css-extract-plugin
module.exports = {"MyVisitedPage":"MyVisitedPage_MyVisitedPage__YeDEC","Loader":"MyVisitedPage_Loader__Uh_dP","ListItem":"MyVisitedPage_ListItem__fl6bv"};